import { FC } from 'react'
import { NonUndefined } from 'react-hook-form'

import LoadingButton from '@/components/loading-button'
import { ActionTimer } from '@/hooks/useActionTimer'
import { Logging } from '@/out/logging'
import { Label } from '@/components/ui/label'

type Props = {
  configuration: NonUndefined<Logging['datadog']>
  timer: ActionTimer
  onRemove: () => void
}

const DatadogDetails: FC<Props> = ({ configuration, timer, onRemove }) => {
  return (
    <>
      <div className="pt-2 mb-6 space-y-3">
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">API Key:</Label>
          <span className="text-sm font-medium">{configuration.apiKey}</span>
        </div>
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Site:</Label>
          <span className="text-sm font-medium">{configuration.site}</span>
        </div>
      </div>
      <LoadingButton timer={timer} size="sm" onClick={onRemove} variant="outline-destructive">
        Disconnect
      </LoadingButton>
    </>
  )
}

export default DatadogDetails
